import { api } from './api';

const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') q.append(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const usersApi = {
  list: (params = {}) => api.get(`/users${qs(params)}`),
  get: (id) => api.get(`/users/${id}`),
  create: (body) => api.post('/users', body),
  update: (id, body) => api.patch(`/users/${id}`, body),
  resetPassword: (id, body) => api.post(`/users/${id}/reset-password`, body),
  deactivate: (id) => api.delete(`/users/${id}`),
};

export const rolesApi = {
  list: () => api.get('/roles'),
  get: (id) => api.get(`/roles/${id}`),
  listPermissions: () => api.get('/roles/permissions'),
  create: (body) => api.post('/roles', body),
  update: (id, body) => api.patch(`/roles/${id}`, body),
  remove: (id) => api.delete(`/roles/${id}`),
};

export const entitiesApi = {
  list: () => api.get('/entities'),
  get: (id) => api.get(`/entities/${id}`),
  create: (body) => api.post('/entities', body),
  update: (id, body) => api.patch(`/entities/${id}`, body),
  remove: (id) => api.delete(`/entities/${id}`),
};

export const currenciesApi = {
  list: () => api.get('/currencies'),
  get: (id) => api.get(`/currencies/${id}`),
  create: (body) => api.post('/currencies', body),
  update: (id, body) => api.patch(`/currencies/${id}`, body),
  listRates: (id) => api.get(`/currencies/${id}/rates`),
  addRate: (id, body) => api.post(`/currencies/${id}/rates`, body),
};

export const periodsApi = {
  listFiscalYears: () => api.get('/fiscal/fiscal-years'),
  getFiscalYear: (id) => api.get(`/fiscal/fiscal-years/${id}`),
  createFiscalYear: (body) => api.post('/fiscal/fiscal-years', body),
  addPeriod: (fyId, body) => api.post(`/fiscal/fiscal-years/${fyId}/periods`, body),
  closePeriod: (id) => api.post(`/fiscal/periods/${id}/close`),
  lockPeriod: (id) => api.post(`/fiscal/periods/${id}/lock`),
  reopenPeriod: (id) => api.post(`/fiscal/periods/${id}/reopen`),
};
